import * as $ from "jquery";
import { isMobile } from "./utility";

export function lsatPerfection() {
    const $modal = $(".modal");
    const $modelclose = $modal.find(".fa");
    const $modelmask = $modal.find(".mask");
    const $img = $("#scoreImage");
    $(".scorereport").on("click", function () {
        const src = "/images/scorereport-robin/" + $(this).attr("id") + ".png";
        const title = $(this).closest("tr").find("td:first-child").text();

        // Retrieves image from cloud
        $img.attr("src", src);

        if (isMobile()) {
            // Opens image in new tab for mobile devices
            window.open(src);
        } else {
            // Otherwise opens in a modal
            $modal.find("h2").text(title);
            $modal.css("display", "flex");
        }
    });
    $modelclose.on("click", function () {
        $modal.hide();
    });
    $modelmask.on("click", function () {
        $modal.hide();
    });
}
